import { render } from "./lista_produccion_formatos_terminados.vue?vue&type=template&id=cadd84f8&scoped=true"
import script from "./lista_produccion_formatos_terminados.vue?vue&type=script&lang=js"
export * from "./lista_produccion_formatos_terminados.vue?vue&type=script&lang=js"

import "./lista_produccion_formatos_terminados.vue?vue&type=style&index=0&id=cadd84f8&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cadd84f8"]])

export default __exports__